import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import Button from '@ingka/button';
import { ListViewItem } from '@ingka/list-view';
import arrowUpFromBaseIcon from '@ingka/ssr-icon/paths/arrow-up-from-base';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import type { AssetActionProps } from '../../asset-context-buttons.types';

import styles from '../../styles.module.scss';

const AssetShareButton = () => {
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);

    return (
        <Button
            iconOnly
            size="small"
            type="tertiary"
            ssrIcon={arrowUpFromBaseIcon}
            onClick={() => {
                setActiveModal(MODAL.SHARE);
            }}
            className={String(styles.hide_mobile)}
            data-testid="action-toggle-share"
            aria-label={translate('asset_share_button')}
        />
    );
};

const AssetShareListItem = ({ onClose, context }: AssetActionProps) => {
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    return (
        <ListViewItem
            title={translate('share_modal_option')}
            control="navigational"
            className={String(styles.hide_desktop)}
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.SHARE);
                onClose?.();
            }}
        />
    );
};

export const AssetShareAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return <AssetShareButton key="share-button" {...props} />;
    }
    return <AssetShareListItem key="share-list-item" {...props} />;
};
